<template>
  <div class="page pt-5">
    <app-loader v-if="loader" />
    <template v-else>
      <scanner
        v-if="!succesfullyScannedTTN"
        ref="scanner"
        page-title="Передача перевозчику"
        title="TTN"
        @input="getVinsByScannedTTN"
      />
      <scanner
        v-else
        ref="scanner"
        title="VIN-номер"
        @input="confirmVIN"
      />
      <div class="page__wrapper">
        <v-card
          v-for="it in cars"
          :id="it.vin"
          :key="it.vin"
          elevation="1"
          :color="getCardColor(it.vin)"
          class="mb-5"
        >
          <v-card-text>
            {{ it.vin }} <br>
            <span class="text-transform-none">{{ it.model }}, {{ it.color }}</span>
          </v-card-text>
        </v-card>
      </div>
      <div
        v-if="!isScannerShown"
        class="page__actions"
      >
        <v-btn
          color="error lighten-1"
          x-large
          @click="$router.push('/navigation')"
        >
          Назад
        </v-btn>
        <v-btn
          class="mx-1"
          color="primary"
          x-large
          @click="$router.push('/navigation')"
        >
          <v-icon>mdi-home</v-icon>
        </v-btn>
        <v-btn
          v-if="cars.length && everyVinIsConfirmed && !acceptLoader"
          class="ml-auto"
          color="success"
          x-large
          @click="confirmationModal = true"
        >
          Подтвердить
        </v-btn>
      </div>
      <confirmation-modal
        v-model="confirmationModal"
        @submit="acceptTtn"
      />
      <result-modal
        v-model="resultModal"
        title="ТТН подтверждена"
      />
      <result-modal
        v-model="errorModal"
        :title="errorText"
      />
    </template>
  </div>
</template>

<script>
import ConfirmationModal from '@/components/ConfirmationModal.vue';
import Scanner from '@/components/Scanner.vue';
import ResultModal from '@/components/ResultModal.vue';
import { mapState } from 'vuex';

export default {
  name: 'CarrierTransmission',
  components: {
    ConfirmationModal,
    Scanner,
    ResultModal,
  },
  data: () => ({
    loader: false,
    acceptLoader: false,
    scannedTTN: null,
    succesfullyScannedTTN: false,
    cars: [],
    confirmedVins: [],
    confirmationModal: false,
    resultModal: false,
    errorModal: false,
    errorText: '',
  }),
  computed: {
    ...mapState(['isScannerShown']),
    everyVinIsConfirmed() {
      return this.cars.every((it) => this.confirmedVins.find((confirmed) => confirmed === it.vin));
    },
  },
  methods: {
    async getVinsByScannedTTN(ttn) {
      this.loader = true;
      // TN0000003271
      const { data } = await this.$http.get(`MobileOperatorInterface/CarrierTransmission/Document/${ttn}?status=Сформирована`)
        .catch((e) => {
          this.errorText = e?.response?.data?.errorMess;
          this.errorModal = true;
        }).finally(() => {
          this.loader = false;
        });
      this.cars = data;
      this.scannedTTN = ttn;
      if (!data.length) {
        this.errorText = 'Ничего не найдено';
        this.errorModal = true;
      } else {
        this.succesfullyScannedTTN = true;
      }
      this.loader = false;
    },
    getCardColor(vin) {
      return this.confirmedVins.includes(vin) ? 'success lighten-5' : 'yellow lighten-4';
    },
    confirmVIN(vin) {
      this.confirmedVins.push(vin);
      this.$refs.scanner.stopScanning();
    },
    async acceptTtn() {
      this.acceptLoader = true;
      await this.$http.post(`MobileOperatorInterface/CarrierTransmission/Document/${this.scannedTTN}`, {
        id: this.activeTTN,
        status: 'Подтверждена',
      }).then(() => {
        this.resultModal = true;
        this.succesfullyScannedTTN = false;
        this.cars = [];
        this.confirmedVins = [];
      }).catch((e) => {
        this.errorText = e?.response?.data?.errorMess;
        this.errorModal = true;
      }).finally(() => {
        this.acceptLoader = false;
      });
    },
  },
};
</script>
